// client/src/pages/SuspendedPage.jsx - Compte suspendu
import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

const SuspendedPage = () => {
  return (
    <>
      <Seo
        title="Compte suspendu"
        description="Votre compte YAQAM est suspendu. Contactez le support pour obtenir de l'aide."
        noindex
      />
      <div className="max-w-lg mx-auto text-center py-16">
      <h1 className="text-3xl font-bold mb-4 text-[#2C3E50]">Compte suspendu</h1>
      <p className="text-gray-700 mb-6">
        Votre compte a été suspendu. Si vous pensez qu'il s'agit d'une erreur, contactez le support.
      </p>
      <div className="mb-8 text-[#2C3E50]">
        <a href="mailto:jeremie.assezat@essec.edu" className="text-[#87A96B] hover:text-[#87A96B]/80 font-medium">jeremie.assezat@essec.edu</a>
      </div>
      <div className="flex gap-3 justify-center">
        <Link to="/" className="px-6 py-3 bg-gray-100 text-[#2C3E50] rounded-full font-medium hover:bg-gray-200 transition-all">Accueil</Link>
        <Link to="/login" className="px-6 py-3 bg-[#87A96B] text-white rounded-full font-medium hover:bg-[#87A96B]/90 transition-all">Se connecter</Link>
      </div>
    </div>
    </>
  );
};

export default SuspendedPage;
